import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';
import { Globe, TriangleAlert } from 'lucide-react';
import { Card, EmptyState, StatusPill, TableSkeleton } from '@/components/ui';
import { SITE_HEALTH } from '@/utils/labels';
import type { OverviewSnapshot } from '@/types/api';

/**
 * The sites that are not plainly healthy, worst first: what someone opening the
 * dashboard at three in the morning is looking for.
 */
export function AttentionCard({ overview }: { readonly overview: OverviewSnapshot | null | undefined }): ReactNode {
  const unhealthy = overview?.attention ?? [];

  return (
    <Card
      title={overview && overview.sites.needAttention > 0 ? `Требуют внимания: ${overview.sites.needAttention}` : 'Требуют внимания'}
      icon={TriangleAlert}
      flush
      actions={
        <Link to="/sites" className="btn btn-ghost btn-sm">
          Все сайты
        </Link>
      }
    >
      {overview === undefined ? (
        <TableSkeleton rows={3} columns={2} />
      ) : unhealthy.length === 0 ? (
        <EmptyState icon={Globe} message="Все сайты работают" />
      ) : (
        <div className="table-scroll">
          <table>
            <tbody>
              {unhealthy.slice(0, 6).map((site) => (
                <tr key={site.id}>
                  <td>
                    <Link to={`/sites/${site.id}`} className="strong">
                      {site.displayName}
                    </Link>
                    <div className="mono faint text-sm">{site.primaryDomain ?? site.slug}</div>
                  </td>
                  <td className="shrink">
                    <StatusPill map={SITE_HEALTH} status={site.healthStatus} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
}
